// extracted by mini-css-extract-plugin
module.exports = {"promoCarouselBlock":"promoCarouselBlock_promoCarouselBlock__GcINJ"};